import React, { useState } from 'react';
import PropTypes from 'prop-types';
import JSForm from '../../Form';
import { uiSchema } from './utils';
import useGetSchema from './useGetSchema';
import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(({
  container: {
    padding: '40px'
  },
  progress: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const StepConfigNotification = ({ onChange, setIsValid, data }) => {
  const [formDataState, setFormDataState] = useState(data.step1);
  const [schema, templates, loading] = useGetSchema(formDataState);
  const classes = useStyles();

  const handleOnChange = (formData) => {
    let template;
    if (formData.type && templates) {
      template = templates.find((template) => template.templateid === formData.templateId);
    }
    onChange((prv) => ({
      ...prv,
      step1: { ...formData, template } }));
    setFormDataState(formData);
    if (schema.required.every((key) => formData[key] !== undefined)) {
      setIsValid(true);
    }
  };

  if (loading) {
    return (
      <div className={classes.progress} >
        <CircularProgress />;
      </div>);
  }

  return (
    <div className={classes.container}>
      <JSForm
        schema={schema}
        formData={formDataState || data.step1}
        onChange={({ formData }) => handleOnChange(formData)}
        uiSchema={uiSchema}
      />
    </div>
  );
};

StepConfigNotification.propTypes = {
  onChange: PropTypes.func.isRequired,
  setIsValid: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default StepConfigNotification;
